import type { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { KibGrid } from '@chewy/kib-layout-react'

import ClientInfo from '~/components/dashboard/soapV2/summary/patient-details/ClientInfo'
import { getUser } from '~/store/reducers/users'

import styles from './ClientDetailsHeader.module.scss'

export interface ClientDetailsHeaderProps {
  actionsSlot?: ReactNode
  clientId?: string
}

const ClientDetailsHeader: FC<ClientDetailsHeaderProps> = ({
  clientId,
  actionsSlot,
}) => {
  const client = useSelector(getUser(clientId))

  return (
    <KibGrid className={styles.container}>
      <ClientInfo client={client} hasActionsSlot={Boolean(actionsSlot)} />
      {actionsSlot && (
        <div className={styles.menuButtonContainer}>{actionsSlot}</div>
      )}
    </KibGrid>
  )
}

export default ClientDetailsHeader
